import React, { useEffect, useState } from 'react';
import { Typography, Upload } from 'antd';
const { Text } = Typography;
import { PlusOutlined } from "@ant-design/icons";
import TextArea from 'antd/es/input/TextArea';
import { useCreateTicket } from './store';
import useAssignedStore from 'modules/my_tickets/assigned_tickets/store';
import imageCompression from "browser-image-compression";
import _ from 'lodash';
import secureLocalStorage from 'react-secure-storage';
import { noSlotInMedicalEscalation } from 'modules/utilities/utility';
import { LOCAL_STORAGE_CONFIG } from "config";
const { ID } = LOCAL_STORAGE_CONFIG;

const TicketDescription = ({ setTicketPayload, setValidation }) => {
    useEffect(() => { setValidation(prevValidation => ({ ...prevValidation, description: false })) }, [])
    const { ticketResponse } = useCreateTicket();
    const { updateImageData } = useAssignedStore();

    const [fileList, setFileList] = useState([]);

    const setDescription = (comment) => {
        if (comment.length) {
            setValidation(prevValidation => ({ ...prevValidation, description: comment.trim() ? true : false }))
        }
        setTicketPayload((prevPayload) => {
            const { category, provider_meta, sub_category } = prevPayload;
            const data = {
                ...prevPayload,
                comment: { commented_by: ID, description: comment, type: category },
                provider_meta: { ...provider_meta, description: comment }
            }
            if (category === 'medical_escalations' && !noSlotInMedicalEscalation(sub_category)) { data.manual_medical_slot = true }
            else { data.manual_medical_slot = false }
            if (category === 'product_related_quality_issues') { data.is_internal = true }
            return data;
        })
    }

    const handleFileChange = (info) => {
        setFileList(info.fileList);
    };

    useEffect(() => {
        const ticketId = _.get(ticketResponse, '_id');
        const uploadImage = async () => await uploadFile(ticketId);
        uploadImage();

    }, [ticketResponse]);

    const handleFakeRequest = ({ onSuccess }) => {
        return setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };

    const uploadFile = async (ticketId) => {
        const options = {
            maxSizeMB: 5,
            useWebWorker: true,
        };

        const imageDataArray = [];

        for (let image = 0; image < fileList?.length; image++) {
            const file = fileList[image];
            const type = fileList[image]?.type;
            let fileData = new FormData();
            let compressedFile = null;
            if (type !== "application/pdf") {
                compressedFile = await imageCompression(file.originFileObj, options);
            } else {
                compressedFile = file.originFileObj;
            }
            fileData.append("file", compressedFile, file.name);
            imageDataArray.push(fileData);
        }
        const uploadImage = imageDataArray?.map(async (item) => {
            return updateImageData(item, ticketId);
        });
        await Promise.all(uploadImage);
    };

    return (
        <div>

            <div className='mb-3'>
                <Text>Description</Text>
                <TextArea
                    rows={4}
                    onPaste={(event) => { setDescription(event.clipboardData.getData('Text')) }}
                    onChange={(event) => { setDescription(event.target.value) }}
                    onKeyUp={(event) => { setDescription(event.currentTarget.value) }}
                />
            </div>
            <div className='mb-3'>
                <Text>Upload Photo</Text>
                <Upload
                    accept="image/png, image/jpeg, application/pdf"
                    listType="picture-card"
                    customRequest={handleFakeRequest}
                    onChange={handleFileChange}
                    onPreview={(file) => {
                        if (typeof window.URL.createObjectURL === "function") {
                            const url = window.URL.createObjectURL(
                                file.originFileObj
                            );
                            window.open(url, "_blank").focus();
                        }
                    }}
                >
                    <div className="flex flex-col gap-2">
                        <PlusOutlined />
                        <span>Upload</span>
                    </div>
                </Upload>
            </div>
        </div>
    )
}

export default TicketDescription